import React from 'react';
import { SharedEffects } from './SharedEffects';

const traces = [
  { path: 'M0,80 L180,80 L180,160 L360,160 L360,80 L520,80', nodes: [[0,80],[180,80],[180,160],[360,160],[360,80],[520,80]] },
  { path: 'M520,80 L520,200 L700,200 L700,120 L900,120', nodes: [[520,200],[700,200],[700,120],[900,120]] },
  { path: 'M0,340 L120,340 L120,420 L300,420 L300,340 L460,340 L460,260 L620,260', nodes: [[0,340],[120,340],[120,420],[300,420],[300,340],[460,340],[460,260],[620,260]] },
  { path: 'M620,260 L620,380 L800,380 L800,300 L980,300 L980,420 L1120,420', nodes: [[620,380],[800,380],[800,300],[980,300],[980,420],[1120,420]] },
  { path: 'M900,120 L1060,120 L1060,200 L1200,200 L1200,80 L1440,80', nodes: [[1060,120],[1060,200],[1200,200],[1200,80]] },
  { path: 'M0,600 L160,600 L160,700 L340,700 L340,620 L500,620 L500,740 L680,740', nodes: [[0,600],[160,600],[160,700],[340,700],[340,620],[500,620],[500,740],[680,740]] },
  { path: 'M680,740 L680,660 L860,660 L860,780 L1040,780 L1040,700 L1200,700', nodes: [[680,660],[860,660],[860,780],[1040,780],[1040,700],[1200,700]] },
  { path: 'M1120,420 L1280,420 L1280,540 L1440,540', nodes: [[1280,420],[1280,540]] },
  { path: 'M1200,700 L1340,700 L1340,600 L1440,600', nodes: [[1340,700],[1340,600]] },
  { path: 'M300,160 L300,340', nodes: [] },
  { path: 'M800,200 L800,300', nodes: [] },
  { path: 'M1200,200 L1200,420', nodes: [] },
];

const pulsePaths = [
  { path: traces[0].path, dur: '4s', delay: '0s' },
  { path: traces[1].path, dur: '3s', delay: '1s' },
  { path: traces[2].path, dur: '5s', delay: '0.5s' },
  { path: traces[3].path, dur: '4.5s', delay: '2s' },
  { path: traces[4].path, dur: '3.5s', delay: '1.5s' },
  { path: traces[5].path, dur: '5.5s', delay: '0.3s' },
  { path: traces[6].path, dur: '4s', delay: '2.5s' },
  { path: traces[7].path, dur: '3s', delay: '1.8s' },
  { path: traces[8].path, dur: '3.5s', delay: '0.8s' },
];

export function CircuitOverlay() {
  return (
    <div className="auth-overlay">
      <svg xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="none" viewBox="0 0 1440 900">
        <defs>
          <filter id="circuit-glow">
            <feGaussianBlur stdDeviation="3" result="coloredBlur" />
            <feMerge>
              <feMergeNode in="coloredBlur" />
              <feMergeNode in="SourceGraphic" />
            </feMerge>
          </filter>
          <filter id="node-glow">
            <feGaussianBlur stdDeviation="5" result="coloredBlur" />
            <feMerge>
              <feMergeNode in="coloredBlur" />
              <feMergeNode in="SourceGraphic" />
            </feMerge>
          </filter>
        </defs>

        {traces.map((trace, i) => (
          <g key={`trace-${i}`}>
            <path d={trace.path} fill="none" stroke="#4285F4" strokeWidth="3" opacity="0.06" filter="url(#circuit-glow)" />
            <path d={trace.path} fill="none" stroke="#4285F4" strokeWidth="1" opacity="0.18" strokeLinejoin="round" />
          </g>
        ))}

        {traces.flatMap((trace, ti) =>
          trace.nodes.map((node, ni) => (
            <g key={`node-${ti}-${ni}`}>
              <circle cx={node[0]} cy={node[1]} r="6" fill="none" stroke="#4285F4" strokeWidth="0.5" opacity="0.15" className="circuit-node-ring" style={{ animationDelay: `${(ti * 0.3 + ni * 0.2) % 4}s` }} />
              <circle cx={node[0]} cy={node[1]} r="2" fill="#4285F4" opacity="0.3" className="circuit-node-dot" style={{ animationDelay: `${(ti * 0.5 + ni * 0.3) % 3}s` }} />
            </g>
          ))
        )}

        {pulsePaths.map((p, i) => (
          <g key={`pulse-${i}`}>
            <circle r="3" fill="#4285F4" filter="url(#node-glow)">
              <animateMotion dur={p.dur} repeatCount="indefinite" path={p.path} begin={p.delay} />
              <animate attributeName="opacity" values="0;0.8;0.8;0.8;0" dur={p.dur} repeatCount="indefinite" begin={p.delay} />
            </circle>
            <circle r="6" fill="#4285F4" opacity="0.15" filter="url(#circuit-glow)">
              <animateMotion dur={p.dur} repeatCount="indefinite" path={p.path} begin={p.delay} />
              <animate attributeName="opacity" values="0;0.2;0.2;0.2;0" dur={p.dur} repeatCount="indefinite" begin={p.delay} />
            </circle>
          </g>
        ))}

        <circle r="2" fill="#ffffff">
          <animateMotion dur="5s" repeatCount="indefinite" path={traces[3].path} keyPoints="1;0" keyTimes="0;1" />
          <animate attributeName="opacity" values="0;0.35;0.35;0" dur="5s" repeatCount="indefinite" />
        </circle>
        <circle r="2" fill="#ffffff">
          <animateMotion dur="6s" repeatCount="indefinite" path={traces[5].path} keyPoints="1;0" keyTimes="0;1" begin="1s" />
          <animate attributeName="opacity" values="0;0.3;0.3;0" dur="6s" repeatCount="indefinite" begin="1s" />
        </circle>
        <circle r="1.5" fill="#ffffff">
          <animateMotion dur="4.5s" repeatCount="indefinite" path={traces[0].path} keyPoints="1;0" keyTimes="0;1" begin="2s" />
          <animate attributeName="opacity" values="0;0.25;0.25;0" dur="4.5s" repeatCount="indefinite" begin="2s" />
        </circle>
      </svg>

      <SharedEffects />
    </div>
  );
}
